
import { RequestBasePageIds, RequestBaseSet, RequestDeleteIds, ResponseBasePage, ResponseBaseSet } from "src/app/modules/fwcore/models";
import { ValueDependency } from "src/app/features/prob/models";


export class RequestValueDependency extends RequestBasePageIds {

  /**
   * Gets or sets a filter to return all records for the given source model value identifier.
   */
  srcModelValueId?: string | null;

  /** Gets or sets a filter to return all records for the given deal type. */
  dealTypeId?: string | null;

  /** Gets or sets a filter to return all records for the given deal group. */
  dealGroupId?: string | null;
}

export class ResponseValueDependency extends ResponseBasePage<ValueDependency> {
}

export class RequestValueDependencySet extends RequestBaseSet<ValueDependency> {
}

export class ResponseValueDependencySet extends ResponseBaseSet<ValueDependency> {
}

export class RequestValueDependencyDelete extends RequestDeleteIds {

  /**
   * Optional. Remove all dependencies for the source model value identifier.
   */
  srcModelValueId?: string | null;

}
